import BarcodeScreen from 'features/moveMoney/screens/depositCash/BarcodeScreen/BarcodeScreen';

export default BarcodeScreen;
